import { render, staticRenderFns } from "./board_top_bar.vue.js?vue&type=template&id=7b503655&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_top_bar.vue?vue&type=template&id=7b503655&vue3"
import script from "./board_top_bar.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_top_bar.vue?vue&type=script&lang=js&vue3"
export * from "./board_top_bar.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_top_bar.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports